import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { PopoverArrow, PopoverBody, PopoverHeader } from '@chakra-ui/react';
export const NotificationPopOverBodyWrapper = ({ bodyOverflow, children, }) => {
    const { t } = useTranslation('shared');
    return (_jsxs(_Fragment, { children: [_jsx(PopoverHeader, { fontWeight: 'semibold', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 4, color: 'neutral400', pl: 5, children: t('navigation.notifications') }), _jsx(PopoverArrow, { ml: { base: '15px', md: 'initial' } }), _jsx(PopoverBody, { overflow: bodyOverflow, children: children })] }));
};
